
export default class HelperArrays{

    constructor(){

    }

    joiners(){
        return [
            {
                text: 'and',
                value: ', and',
                isJoiner: true
            },
            {
                text: 'but',
                value: ', but',
                isJoiner: true
            },
            {
                text: 'however',
                value: ', however',
                isJoiner: true
            },
            {
                text: 'even',
                value: ', even',
                isJoiner: true
            },
            {
                text: 'additionally',
                value: ', additionally',
                isJoiner: true
            }
        ];
    }

}


// WEBPACK FOOTER //
// ./src/services/HelperArrays.js